import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wenhao",
  "use": "icon-wenhao-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-wenhao\">\r\n<path d=\"M100,0C44.8,0,0,44.8,0,100s44.8,100,100,100s100-44.8,100-100S155.2,0,100,0L100,0z M100,187.5\r\n\tc-48.3,0-87.5-39.3-87.5-87.5c0-48.2,39.2-87.5,87.5-87.5s87.5,39.3,87.5,87.5S148.3,187.5,100,187.5L100,187.5z\" />\r\n<path d=\"M90.9,147.9c0,2.4,1,4.8,2.7,6.4c1.7,1.7,4.1,2.7,6.4,2.7c2.4,0,4.8-1,6.4-2.7s2.7-4.1,2.7-6.4c0-2.4-1-4.8-2.7-6.4\r\n\tc-1.7-1.7-4.1-2.7-6.4-2.7c-2.4,0-4.8,1-6.4,2.7C91.9,143.1,90.9,145.5,90.9,147.9L90.9,147.9z\" />\r\n<path d=\"M100,41.7c-16.8,0-30.4,13.5-30.4,30.1c0,3.4,2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1c0-10.1,8-18,18.2-18\r\n\tc10.1,0,18.2,8.2,18.2,18.4c0,4.1-5.1,9.1-10,14.1c-6.7,6.7-14.3,14.3-14.3,24.2v10.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1\r\n\tv-10.3c0-4.9,5.5-10.4,10.7-15.6c6.7-6.7,13.6-13.6,13.6-22.7C130.4,55.4,116.8,41.7,100,41.7L100,41.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wenhao.svg
// module id = HXEi
// module chunks = 13